import { Component, OnInit } from '@angular/core';
import { SpeakerService } from './common/services/speaker.service';
import { ThemeService } from './common/services/theme';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',

	standalone: false,
})
export class AppComponent implements OnInit {

	constructor (
		private themeService: ThemeService,
		private speaker: SpeakerService,
	) {
	}

	async ngOnInit () {
		await this.themeService.loadInitialTheme();
		void this.speaker.getVoiceList();
	}
}
